module.exports = __webpack_public_path__ + "img/petstairs43.1eedd254.jpg";